import Vue from 'vue';
import VueRouter from 'vue-router';
import { Platform } from 'quasar';

import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default function ({ store }) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as is and change from quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });

  Router.beforeEach((to, from, next) => {
    if (store.state.application.closed && to.path !== '/closed') {
      next({ path: '/closed', replace: true });
    }
    else if (Platform.is.desktop && to.path === '/menu' && !to.query.u) {
      if (store.state.application.isQR) {
        next({ path: '/menu/category/8', replace: true });
      }
      else {
        next({ path: '/menu/category/1', replace: true });
      }
    }
    else if (to.matched.some(record => record.meta.requiresAuth) && !store.getters['user/isLoggedIn']) {
      if (Platform.is.cordova) {
        next({ path: '/login', replace: true });
      }
      else {
        next();
      }
    }
    else {
      next();
    }
  });

  return Router;
}
